module.exports = __webpack_public_path__ + "assets/ios_Filez_prompt.48ef5d760e6b315eb0dd65f16bf620e4.png";